import { __ } from '@wordpress/i18n';

import { horizontalLineIcon, verticalLineIcon } from './icons';

export const themes = [
	{ label: __('Default', 'team-section'), value: 'default' },
	{ label: __('Theme 1', 'team-section'), value: 'theme1' },
	{ label: __('Theme 2', 'team-section'), value: 'theme2' },
	{ label: __('Theme 3', 'team-section'), value: 'theme3' },
	{ label: __('Theme 4', 'team-section'), value: 'theme4' },
];

export const layouts = [
	{ label: __('Vertical', 'team-section'), value: 'vertical', icon: verticalLineIcon },
	{ label: __('Horizontal', 'team-section'), value: 'horizontal', icon: horizontalLineIcon },
];

export const generalStyleTabs = [
	{ name: 'general', title: __('General', 'team-section') },
	{ name: 'style', title: __('Style', 'team-section') }
];